import { getSessionState } from "stores/session"

type EventType = "install" | "visit"

export const trackEvent = (type: EventType, trackId?: number) => {
  if (typeof window === "undefined") return
  if (!trackId) return
  if (
    getSessionState().user.isAdmin ||
    process.env.NODE_ENV === "development"
  ) {
    return
  }

  // Dedup visits within a session so refreshes don't inflate counts.
  // Installs are intentionally not deduped — repeat clicks signal interest.
  if (type === "visit") {
    try {
      const key = `visit:${trackId}`
      if (sessionStorage.getItem(key)) return
      sessionStorage.setItem(key, "1")
    } catch {
      // sessionStorage can throw in private mode — fall through and count it.
    }
  }

  const url = "/api/track-event"
  const payload = JSON.stringify({ trackId, type })

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" })
      if (navigator.sendBeacon(url, blob)) return
    }
  } catch {
    // fall through to fetch
  }

  // Fallback: keepalive fetch survives page unload / new-tab navigation.
  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
    keepalive: true,
  }).catch(() => {})
}
